import React from 'react';
import Homepage from '../components/Homepage'
import {Route, Routes } from "react-router";
import Layout from "./Layout";
import TwentyTwentyFour from "../components/TwentyTwentyFour";

function App() {
  return (
      <Routes>
          <Route element={<Layout />}>
            <Route path="/ff" element={<Homepage />} />
            <Route path="/ff/2024" element={<TwentyTwentyFour />} />
          </Route>
      </Routes>
  );
}

export default App;
